import { render, staticRenderFns } from "./DetailBankSoal.vue?vue&type=template&id=6eaad46b"
import script from "./DetailBankSoal.vue?vue&type=script&lang=js"
export * from "./DetailBankSoal.vue?vue&type=script&lang=js"
import style0 from "./DetailBankSoal.vue?vue&type=style&index=0&id=6eaad46b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports